'use strict';

var _smoothScroll = require('smooth-scroll');

var _smoothScroll2 = _interopRequireDefault(_smoothScroll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*-------------------------
Smooth Scroll
-------------------------*/

document.addEventListener('DOMContentLoaded', function (event) {
  var scroll = new _smoothScroll2.default('a[href*="#"]', {
    speed: 800,
    header: '.main-header',
    updateURL: false
  });

  if (window.location.hash) {
    window.setTimeout(function () {
      var anchor = document.querySelector('' + window.location.hash);
      scroll.animateScroll(anchor);
    }, 1300);
  }
});